<script>
	import { fade, slide, fly } from 'svelte/transition';
	import logo from '$lib/images/logo.svg';
	export let cdek;
</script>

<div
	transition:fade
	style="background: rgba(255, 255, 255, 0.8);"
	class=" h-screen fixed overflow-hidden top-0 left-0 w-full z-20"
>
	<div class="absolute z-30 top-1/2 left-1/2 -mt-4 -ml-2 h-8 w-4 text-gray-600">
		<div class="absolute z-10 -ml-2 h-8 w-8 animate-bounce">
			<img class="animate-spin" width="53" height="32" src={logo} alt="logo" />
		</div>

		<div
			class="absolute top-4 h-5 w-4 animate-bounce border-l-2 border-gray-200"
			style="rotate: -90deg"
		/>
		<div
			class="absolute top-4 h-5 w-4 animate-bounce border-r-2 border-gray-200"
			style="rotate: 90deg"
		/>
	</div>
</div>
